import React, {FC} from 'react';
import {animated, useSpring} from 'react-spring';
import styled from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/helpers/src/internationalization/react';
import {fontSizes, fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface MessageViewerUnreadProps {
  /** When true, the unread indicator will not be displayed. */
  isAutoResponse?: boolean;
  /** When false-y, the unread indicator will not be displayed. */
  isNewUnread?: boolean;
  /** When true, the unread indicator will not be displayed. */
  isUserAuthor?: boolean;
  isVisible?: boolean;
}

/*
 * Style.
 */

const unreadStyle = {
  opacity: 1,
};

const readStyle = {
  opacity: 0,
};

const StyledUnreadDiv = styled(animated.div)`
  margin-left: 7px;
  padding: 2px 4px;

  border-radius: 3px;
  background-color: ${(p) => p.theme.palette.blue.shade40};

  color: ${(p) => p.theme.greys.white};
  font-size: ${fontSizes.veryTiny};
  font-weight: ${fontWeights.bold};
  text-transform: uppercase;
  letter-spacing: 0.17px;
`;

const StyledTextDiv = styled.div`
  transform: translateY(-0.5px);
`;

function getStyle(props: MessageViewerUnreadProps) {
  if (!props.isVisible) {
    return unreadStyle;
  }

  return readStyle;
}

/*
 * Component.
 */

export const MessageViewerUnread: FC<MessageViewerUnreadProps> = (props) => {
  const toStyle = getStyle(props);
  const springProps = useSpring({
    to: toStyle,
    from: unreadStyle,
    delay: 2000,
    config: {
      duration: 5000,
    },
  });

  if (!props.isNewUnread || props.isUserAuthor || props.isAutoResponse) {
    return null;
  }

  return (
    <StyledUnreadDiv style={springProps}>
      <StyledTextDiv>
        <Trans id="message-detail-new">New</Trans>
      </StyledTextDiv>
    </StyledUnreadDiv>
  );
};
